<template>
  <div class="apartments">
    <div class="apartmentClassSearchBar">
      <div class="topNav__searchbar_wrapper">
        <div class="filterbutton_wrapper">
          <button ref="filterButton" class="filterbutton" @click="toggleFilter">
            <VsxIcon
              iconName="Setting4"
              :size="24"
              color="#000"
              type="linear"
            />
          </button>
        </div>

        <input type="text" class="searchbar_input" placeholder="جستجو..." />
        <div :style="dynamicStyles" class="filter" ref="filterBox">
          <div class="filterTitle">
            <div class="filterTitleContainer">
              <h4>فیلتر</h4>
              <button @click="toggleFilter" class="closeFilterBtn">
                <div class="filterBtnBar"></div>
                <div class="filterBtnBar"></div>
              </button>
            </div>
          </div>
          <div class="filter__container">
            <div class="filter__option filter__option--flex">
              <div class="filter__option_title">دسته بندی</div>
              <div class="filter__option_input filter__option_input--flex">
                <el-select
                  v-model="value1"
                  multiple
                  placeholder="انتخاب"
                  style="width: 240px"
                >
                  <el-option
                    v-for="(v, i) in $store.state.c_set.main_category"
                    :key="i"
                    :value="i"
                    :label="v"
                  />
                </el-select>

                <!--                    <treeselect-->
                <!--                        placeholder="انتخاب کنید..."-->
                <!--                        v-model="value"-->
                <!--                        :multiple="true"-->
                <!--                        :options="options"-->
                <!--                    />-->
              </div>
            </div>
            <div class="filter__option filter__option--flex">
              <div class="filter__option_title">مرتب سازی</div>
              <div class="filter__option_input filter__option_input--flex">
                <el-select
                  v-model="value1"
                  multiple
                  placeholder="انتخاب"
                  style="width: 240px"
                >
                  <el-option
                    v-for="(v, i) in $store.state.c_set.main_category"
                    :key="i"
                    :value="i"
                    :label="v"
                  />
                </el-select>
              </div>
            </div>
            <div class="filter__option filter__option--flex">
              <div class="filter__option_title">تعداد خواب</div>
              <div class="filter__option_input filter__option_input--flex">
                <button
                  class="filter__option_button filter__option_button--increase"
                  @click="filterNumIncrease('room')"
                >
                  <VsxIcon
                    iconName="Add"
                    :size="24"
                    color="#fff"
                    type="linear"
                  />
                </button>
                <div class="filter__option_num">
                  <span>{{ filterRoomNum }}</span>
                </div>
                <button
                  class="filter__option_button filter__option_button--decrease"
                  @click="filterNumDecrease('room')"
                >
                  <VsxIcon
                    iconName="Minus"
                    :size="24"
                    color="#fff"
                    type="linear"
                  />
                </button>
              </div>
            </div>
            <div class="filter__option filter__option--flex">
              <div class="filter__option_title">تعداد طبقه</div>
              <div class="filter__option_input filter__option_input--flex">
                <button
                  class="filter__option_button filter__option_button--increase"
                  @click="filterNumIncrease('floor')"
                >
                  <VsxIcon
                    iconName="Add"
                    :size="24"
                    color="#fff"
                    type="linear"
                  />
                </button>
                <div class="filter__option_num">
                  <span>{{ filterFloorNum }}</span>
                </div>
                <button
                  class="filter__option_button filter__option_button--decrease"
                  @click="filterNumDecrease('floor')"
                >
                  <VsxIcon
                    iconName="Minus"
                    :size="24"
                    color="#fff"
                    type="linear"
                  />
                </button>
              </div>
            </div>
            <div class="filter__option filter__option--flex">
              <div class="filter__option_title">سند مالکیت</div>
              <div class="filter__option_input filter__option_input--flex">
                <div
                  class="customCheckbox"
                  :class="{ checked: documentChecked }"
                >
                  <img src="/img/tickIcon2.png" alt="" />
                  <input
                    type="checkbox"
                    class="chackbox_inpt"
                    v-model="documentChecked"
                  />
                </div>
              </div>
            </div>
            <div class="filter__option filter__option--block">
              <div class="filter__option_title">
                <div class="filterPriceTitle">
                  قیمت :
                  <div class="filterPriceInputContainer">
                    <span class="filterMaxPrice">
                      <input
                        style="text-align: left"
                        type="number"
                        class="filterPriceInput"
                        v-model.number="priceRange[1]"
                      />
                      حداکثر
                    </span>
                    <span class="filterMinPrice">
                      <input
                        style="text-align: left"
                        type="number"
                        class="filterPriceInput"
                        v-model.number="priceRange[0]"
                      />
                      <span>حداقل</span>
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="filter__option_input filter__option_input--block mt-16"
              >
                <VueSlider
                  v-model="priceRange"
                  :min="minPrice"
                  :max="maxPrice"
                  :interval="1"
                  :tooltip="'never'"
                ></VueSlider>
              </div>
            </div>
            <div class="filterButton__wrapper">
              <button class="searchButton">جستجو کن</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="apartmentsListContainer">
      <RouterLink
        to="/details"
        class="property-list"
        v-for="v in visibleApartments"
        :key="v.id"
      >
        <a>
          <article class="property">
            <!--            <div class="deleteIcon">-->
            <!--              <span class="fa fa-bookmark"></span>-->
            <!--            </div>-->

            <header class="property__ref-info">
              <div class="property__picture">
                <img :src="v.img" :alt="v.content" />
              </div>

              <div class="ShowToUserButton-favorite">
                <button class="button-favorite">
                  <img src="/img/amlakLogo.2d3a376f.png" alt="" />
                </button>

                <div class="ShowToUserButton-favoriteText">
                  مشاور املاک
                  <span style="font-family: 'iranyekanB'">نبض شهر</span>
                </div>
              </div>
            </header>

            <section class="property__main-info">
              <h3 class="property__title">{{ v.title }}</h3>
              <span class="property__location">
                <VsxIcon
                  iconName="Location"
                  :size="28"
                  color="#0096c7 "
                  type="linear"
                />
                {{ v.address }}
              </span>
            </section>

            <div class="ShowPriceToUsView">
              <p v-if="v.main_category_en == 'rent'">{{ v.rent_price }}</p>

              <p v-if="v.main_category_en == 'trade'">{{ v.total_price }}</p>

              <div class="LeftIconShowPriceToUsView">
                <VsxIcon
                  iconName="DollarCircle"
                  :size="25"
                  color="#0096c7 "
                  type="linear"
                />
              </div>
            </div>
            <footer class="property__amenities">
              <div class="property__amenity">
                <div class="property__amenity-icon">
                  <svg
                    fill="#000000"
                    height="25px"
                    width="25px"
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 512 512"
                    xml:space="preserve"
                  >
                    <g>
                      <g>
                        <path
                          d="M478.609,225.48v-86.35c0-46.03-37.448-83.478-83.478-83.478H116.87c-46.03,0-83.478,37.448-83.478,83.478v86.35
                          C13.959,232.372,0,250.93,0,272.696c0,12.589,0,89.885,0,100.174c0,9.22,7.475,16.696,16.696,16.696h16.696v50.087
                          c0,9.22,7.475,16.696,16.696,16.696h66.783c9.22,0,16.696-7.475,16.696-16.696v-50.087h244.87v50.087
                          c0,9.22,7.475,16.696,16.696,16.696h66.783c9.22,0,16.696-7.475,16.696-16.696v-50.087h16.696c9.22,0,16.696-7.475,16.696-16.696
                          c0-9.493,0-86.461,0-100.174C512,250.93,498.041,232.372,478.609,225.48z M66.783,139.13c0-27.618,22.469-50.087,50.087-50.087
                          H395.13c27.618,0,50.087,22.469,50.087,50.087v83.478h-33.391v-16.696c0-27.618-22.469-50.087-50.087-50.087h-72.348
                          c-12.819,0-24.523,4.846-33.391,12.794c-8.869-7.948-20.572-12.794-33.391-12.794h-72.348c-27.618,0-50.087,22.469-50.087,50.087
                          v16.696H66.783V139.13z M378.435,205.913v16.696H272.696v-16.696c0-9.206,7.49-16.696,16.696-16.696h72.348
                          C370.945,189.217,378.435,196.707,378.435,205.913z M239.304,205.913v16.696H133.565v-16.696c0-9.206,7.49-16.696,16.696-16.696
                          h72.348C231.815,189.217,239.304,196.707,239.304,205.913z M100.174,422.957H66.783v-33.391h33.391V422.957z M445.217,422.957
                          h-33.391v-33.391h33.391V422.957z M478.609,356.174c-14.401,0-412.865,0-445.217,0v-33.391h445.217V356.174z M478.609,289.391
                          H33.391v-16.696c0-9.206,7.49-16.696,16.696-16.696c12.832,0,401.17,0,411.826,0c9.206,0,16.696,7.49,16.696,16.696V289.391z"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
                <span class="property__amenity-value">4</span>
                <span class="property__amenity-label">اتاق</span>
              </div>

              <div class="property__amenity">
                <div class="property__amenity-icon">
                  <svg
                    width="25px"
                    height="25px"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M3 5.00611L3.00018 4.99962C3.01218 4.63969 3.10892 4.26822 3.26943 3.94721C3.39761 3.69084 3.57419 3.46489 3.82033 3.3008C4.06021 3.14088 4.42499 3 5 3C5.57502 3 5.9398 3.14088 6.17967 3.3008C6.48866 3.50679 6.69219 3.8208 6.81777 4.14477C6.22162 4.30128 5.72626 4.57709 5.32555 4.93481C4.70429 5.48942 4.3823 6.17607 4.21313 6.72163C4.02059 7.34253 4.19257 7.9476 4.56764 8.37037C4.92761 8.77611 5.45463 9 6 9H10C10.5454 9 11.0724 8.77611 11.4324 8.37037C11.8074 7.9476 11.9794 7.34253 11.7869 6.72163C11.6177 6.17607 11.2957 5.48942 10.6745 4.93481C10.2084 4.51876 9.61431 4.2135 8.88252 4.07789C8.81351 3.77563 8.70182 3.41757 8.51943 3.05279C8.27261 2.55916 7.88669 2.03511 7.28908 1.6367C6.68521 1.23412 5.92499 1 5 1C4.07502 1 3.3148 1.23412 2.71092 1.6367C2.11331 2.03511 1.72739 2.55916 1.48057 3.05279C1.23572 3.5425 1.11827 4.02011 1.06048 4.36685C1.02595 4.57403 1.00127 4.78516 1.00001 4.99552L1 13C1.00011 13.0906 1.00205 13.1801 1.00864 13.3416C1.01708 13.5482 1.0338 13.8399 1.067 14.1886C1.13297 14.8812 1.26604 15.8212 1.53848 16.7747C1.80759 17.7166 2.23337 18.7464 2.92824 19.557C3.64853 20.3974 4.66199 21 6 21L6 22C6 22.5523 6.44772 23 7 23C7.55229 23 8 22.5523 8 22V21H16V22C16 22.5523 16.4477 23 17 23C17.5523 23 18 22.5523 18 22L18 21C20.0879 21 21.3006 19.566 21.9601 18.1431C22.6171 16.7257 22.8534 15.0872 22.9426 14.0842C23.048 12.8984 22.0873 12 21 12H3V5.00611ZM3.0581 14C3.11716 14.6197 3.23408 15.4292 3.46152 16.2253C3.69241 17.0334 4.01663 17.7536 4.44676 18.2555C4.85147 18.7276 5.33801 19 6 19H18C18.9628 19 19.6375 18.3981 20.1456 17.302C20.6394 16.2366 20.8536 14.926 20.9419 14H3.0581ZM9.34254 6.42679C9.52126 6.58633 9.65602 6.78564 9.75612 7H6.24388C6.34398 6.78564 6.47874 6.58633 6.65746 6.42679C6.90165 6.2088 7.29876 6 8 6C8.70124 6 9.09836 6.2088 9.34254 6.42679Z"
                      fill="#0F0F0F"
                    />
                  </svg>
                </div>
                <span class="property__amenity-value">2</span>
                <span class="property__amenity-label">حمام</span>
              </div>

              <div class="property__amenity">
                <div class="property__amenity-icon">
                  <svg
                    width="25px"
                    height="25px"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M22 22L2 22"
                      stroke="#1C274C"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M3 22.0001V11.3472C3 10.4903 3.36644 9.67432 4.00691 9.10502L10.0069 3.77169C11.1436 2.76133 12.8564 2.76133 13.9931 3.77169L19.9931 9.10502C20.6336 9.67432 21 10.4903 21 11.3472V22.0001"
                      stroke="#1C274C"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M10 9H14"
                      stroke="#1C274C"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M9 15.5H15"
                      stroke="#1C274C"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M9 18.5H15"
                      stroke="#1C274C"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M18 22V16C18 14.1144 18 13.1716 17.4142 12.5858C16.8284 12 15.8856 12 14 12H10C8.11438 12 7.17157 12 6.58579 12.5858C6 13.1716 6 14.1144 6 16V22"
                      stroke="#1C274C"
                      stroke-width="1.5"
                    />
                  </svg>
                </div>
                <span class="property__amenity-value">2</span>
                <span class="property__amenity-label">پارکینگ</span>
              </div>

              <div class="property__amenity">
                <div class="property__amenity-icon">
                  <svg
                    fill="#000000"
                    height="25px"
                    width="25px"
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 491.541 491.541"
                    xml:space="preserve"
                  >
                    <g>
                      <path
                        d="M350.373,116.048H24.445C10.942,116.048,0,126.988,0,140.492V466.42c0,13.503,10.942,24.445,24.445,24.445h325.928
                        c13.503,0,24.444-10.942,24.444-24.445V140.492C374.817,126.988,363.876,116.048,350.373,116.048z M325.928,441.975H48.889V164.936
                        h277.039V441.975z"
                      />
                      <path
                        d="M486.695,411.913h-26.513V126.63h26.513c1.958,0,3.724-1.178,4.472-2.991c0.756-1.814,0.342-3.892-1.05-5.283
                        l-42.802-42.802c-1.894-1.894-4.965-1.894-6.858,0l-42.803,42.802c-1.392,1.392-1.806,3.469-1.05,5.283
                        c0.749,1.813,2.515,2.991,4.473,2.991h26.513v285.283h-26.513c-1.958,0-3.724,1.177-4.473,2.991
                        c-0.755,1.815-0.342,3.893,1.05,5.285l42.803,42.802c1.893,1.894,4.965,1.894,6.858,0l42.802-42.802
                        c1.393-1.392,1.807-3.469,1.05-5.285C490.419,413.09,488.654,411.913,486.695,411.913z"
                      />
                      <path
                        d="M70.676,94.563c1.392,1.392,3.469,1.806,5.284,1.05c1.814-0.747,2.992-2.514,2.992-4.472V64.628h285.283v26.513
                        c0,1.958,1.177,3.725,2.991,4.472c1.814,0.756,3.891,0.342,5.284-1.05l42.802-42.802c1.894-1.895,1.894-4.967,0-6.86L372.51,2.1
                        c-1.393-1.393-3.469-1.807-5.284-1.051c-1.814,0.748-2.991,2.514-2.991,4.472v26.515H78.952V5.521c0-1.957-1.177-3.724-2.992-4.472
                        c-1.814-0.756-3.892-0.342-5.284,1.051L27.875,44.901c-1.894,1.893-1.894,4.965,0,6.86L70.676,94.563z"
                      />
                    </g>
                  </svg>
                </div>
                <span class="property__amenity-value">180</span>
                <span class="property__amenity-label">مترمربع</span>
              </div>
            </footer>
          </article>
        </a>
      </RouterLink>
    </div>

    <div
      v-if="typeMelk.length >= visibleCount"
      class="apartmentsLoadMoreDataButton"
    >
      <button class="loadButton" @click="loadMore" :disabled="isLoading">
        <span v-if="!isLoading">نمایش بیشتر</span>
        <span v-else class="apertmentLoader loader"></span>
      </button>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  watch,
  computed,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
} from "vue";
import VueSlider from "vue-3-slider-component";
// import Treeselect from "vue3-treeselect";
// import "vue3-treeselect/dist/vue3-treeselect.css";

const visibleCount = ref(12);
const isLoading = ref(false);
const documentChecked = ref(false);
const value1 = ref([]);
const filterRoomNum = ref(0);
const filterFloorNum = ref(0);
const priceRange = ref([0, 20000000000]);
const minPrice = ref(0);
const maxPrice = ref(20000000000);
const isFilterOpen = ref(false);
const windowWidth = ref(window.innerWidth);
const dynamicStyles = ref(
  windowWidth.value < 576
    ? "position: fixed; left:0; right:0; bottom:0; top:auto !important; width: 100% !important; height:100% !important; z-index:99999; border-radius:0 !important; transform:translateY(100%);  transition: all 0.3s ease;"
    : "height: 0; overflow: hidden; transition: height 0.3s ease;visibility: hidden;"
);
const filterButton = ref(null);
const filterBox = ref(null);
const errors = ref({
  min: "",
  max: "",
});

const updateWidth = () => {
  windowWidth.value = window.innerWidth;
};

const visibleApartments = computed(() => {
  return typeMelk.slice(0, visibleCount.value);
});

const loadMore = () => {
  isLoading.value = true;

  setTimeout(() => {
    visibleCount.value += 12;
    isLoading.value = false;
  }, 500);
};

const filterNumIncrease = (option) => {
  if (option === "room") {
    filterRoomNum.value += 1;
  } else if (option === "floor") {
    filterFloorNum.value += 1;
  }
};

const filterNumDecrease = (option) => {
  if (option === "room" && filterRoomNum.value > 0) {
    filterRoomNum.value -= 1;
  } else if (option === "floor" && filterFloorNum.value > 0) {
    filterFloorNum.value -= 1;
  }
};

const toggleFilter = () => {
  isFilterOpen.value = !isFilterOpen.value;
  dynamicStyles.value = isFilterOpen.value
    ? windowWidth.value < 576
      ? "position: fixed; left:0; right:0; bottom:0; top:auto !important; width: 100% !important; height:100% !important; z-index:2003; border-radius:0 !important; transform:translateY(0);  transition: all 0.3s ease;"
      : "height: 492px; overflow: hidden; transition: height 0.3s ease;"
    : windowWidth.value < 576
    ? "position: fixed; left:0; right:0; bottom:0; top:auto !important; width: 100% !important; height:100% !important; z-index:2003; border-radius:0 !important; transform:translateY(100%);  transition: all 0.3s ease;"
    : "height: 0; overflow: hidden; transition: height 0.3s ease;";

  if (!isFilterOpen.value && windowWidth.value > 576) {
    dynamicStyles.value = "visibility: hidden;";
  }

  if (windowWidth.value < 576 && isFilterOpen.value) {
    document.body.style = "overflow-y: hidden";
  } else if (windowWidth.value < 576 && !isFilterOpen.value) {
    document.body.style = "overflow-y: auto";
  }
};

const validatePrice = () => {
  if (priceRange.value[0] < minPrice.value) {
    errors.value.min = `حداقل قیمت نمی‌تواند کمتر از ${minPrice.value} باشد.`;
    priceRange.value[0] = minPrice.value;
  } else if (priceRange.value[0] > priceRange.value[1]) {
    errors.value.min = "حداقل قیمت نمی‌تواند بیشتر از حداکثر قیمت باشد.";
    priceRange.value[0] = priceRange.value[1];
  } else {
    errors.value.min = "";
  }

  if (priceRange.value[1] > maxPrice.value) {
    errors.value.max = `حداکثر قیمت نمی‌تواند بیشتر از ${maxPrice.value} باشد.`;
    priceRange.value[1] = maxPrice.value;
  } else if (priceRange.value[1] < priceRange.value[0]) {
    errors.value.max = "حداکثر قیمت نمی‌تواند کمتر از حداقل قیمت باشد.";
    priceRange.value[1] = priceRange.value[0];
  } else {
    errors.value.max = "";
  }
};

watch(priceRange, validatePrice, { deep: true });

const typeMelk = [
  {
    img: "https://cdn.jabama.com/image/516x324/jabama-images/2612552/20aa9fb4-5064-4eb3-9c1d-e61dde4081a8.jpeg",
    title: " آپارتمان دوخوابه خانه سبز B3 نیاوران ",
    rent_price: "300,000,000 تومان",
    total_price: "300,000,000 تومان",
    address: "بابل و میدان شهید بزاز",
    main_category_en: "trade",
  },
  {
    img: "https://cdn.jabama.com/image/516x324/jabama-images/800820/1b950bbd-9933-42a3-991c-b24c9a64fdea.jpg",
    title: " آپارتمان دوخوابه خانه سبز B3 نیاوران ",
    rent_price: "300,000,000 تومان",
    total_price: "300,000,000 تومان",
    address: "بابل و میدان شهید بزاز",
    main_category_en: "trade",
  },
  {
    img: "https://cdn.jabama.com/image/516x324/jabama-images/1479506/ee6e569d-8475-4994-a66a-fc607d369632.jpg",
    title: " آپارتمان دوخوابه خانه سبز B3 نیاوران ",
    rent_price: "300,000,000 تومان",
    total_price: "300,000,000 تومان",
    address: "بابل و میدان شهید بزاز",
    main_category_en: "trade",
  },
  {
    img: "https://cdn.jabama.com/image/516x324/jabama-images/3305542/96355518-900c-4320-81d6-3232bea3062f.jpg",
    title: " آپارتمان دوخوابه خانه سبز B3 نیاوران ",
    rent_price: "300,000,000 تومان",
    total_price: "300,000,000 تومان",
    address: "بابل و میدان شهید بزاز",
    main_category_en: "trade",
  },
  {
    img: "https://cdn.jabama.com/image/516x324/jabama-images/1681067/52b35fc3-616a-43f3-93f8-3653824dd794.jpg",
    title: " آپارتمان دوخوابه خانه سبز B3 نیاوران ",
    rent_price: "300,000,000 تومان",
    total_price: "300,000,000 تومان",
    address: "بابل و میدان شهید بزاز",
    main_category_en: "trade",
  },
  {
    img: "https://cdn.jabama.com/image/516x324/jabama-images/image_73ee37e7-aaaa-4b51-b2b9-c09649296ba5.jpg",
    title: " آپارتمان دوخوابه خانه سبز B3 نیاوران ",
    rent_price: "300,000,000 تومان",
    total_price: "300,000,000 تومان",
    address: "بابل و میدان شهید بزاز",
    main_category_en: "trade",
  },
  {
    img: "https://cdn.jabama.com/image/516x324/jabama-images/959393/3ef0a974-c6ce-43d2-8c6a-4818f1f3b5f0.jpg",
    title: " آپارتمان دوخوابه خانه سبز B3 نیاوران ",
    rent_price: "300,000,000 تومان",
    total_price: "300,000,000 تومان",
    address: "بابل و میدان شهید بزاز",
    main_category_en: "trade",
  },
  {
    img: "https://cdn.jabama.com/image/516x324/jabama-images/2055143/7ff06356-24a7-4e55-8b79-502ada31f7b7.jpg",
    title: " آپارتمان دوخوابه خانه سبز B3 نیاوران ",
    rent_price: "300,000,000 تومان",
    total_price: "300,000,000 تومان",
    address: "بابل و میدان شهید بزاز",
    main_category_en: "trade",
  },
  {
    img: "https://cdn.jabama.com/image/516x324/jabama-images/1494419/b27a2b5c-bc4a-4450-84a6-ded952b22ccb.jpeg",
    title: " آپارتمان دوخوابه خانه سبز B3 نیاوران ",
    rent_price: "300,000,000 تومان",
    total_price: "300,000,000 تومان",
    address: "بابل و میدان شهید بزاز",
    main_category_en: "trade",
  },
  {
    img: "https://cdn.jabama.com/image/516x324/jabama-images/1834568/b6360c79-5912-43d7-aac5-d8890749c260.jpg",
    title: " آپارتمان دوخوابه خانه سبز B3 نیاوران ",
    rent_price: "300,000,000 تومان",
    total_price: "300,000,000 تومان",
    address: "بابل و میدان شهید بزاز",
    main_category_en: "trade",
  },
  {
    img: "https://cdn.jabama.com/image/516x324/jabama-images/1479505/3129cc6e-3bec-469f-a892-d689066ad426.jpeg",
    title: " آپارتمان دوخوابه خانه سبز B3 نیاوران ",
    rent_price: "300,000,000 تومان",
    total_price: "300,000,000 تومان",
    address: "بابل و میدان شهید بزاز",
    main_category_en: "trade",
  },
  {
    img: "https://cdn.jabama.com/image/516x324/jabama-images/1479505/27ba994c-22ca-47e1-a18d-917bc30123d5.jpeg",
    title: " آپارتمان دوخوابه خانه سبز B3 نیاوران ",
    rent_price: "300,000,000 تومان",
    total_price: "300,000,000 تومان",
    address: "بابل و میدان شهید بزاز",
    main_category_en: "trade",
  },
  {
    img: "https://cdn.jabama.com/image/516x324/jabama-images/1834568/b6360c79-5912-43d7-aac5-d8890749c260.jpg",
    title: " آپارتمان دوخوابه خانه سبز B3 نیاوران ",
    rent_price: "300,000,000 تومان",
    total_price: "300,000,000 تومان",
    address: "بابل و میدان شهید بزاز",
    main_category_en: "trade",
  },
  {
    img: "https://cdn.jabama.com/image/516x324/jabama-images/3566761/4c68aa33-7e63-404e-b95c-b34f68547ee0.jpg",
    title: " آپارتمان دوخوابه خانه سبز B3 نیاوران ",
    rent_price: "300,000,000 تومان",
    total_price: "300,000,000 تومان",
    address: "بابل و میدان شهید بزاز",
    main_category_en: "trade",
  },
];

const handleClickOutside = (event) => {
  if (
    filterButton.value &&
    isFilterOpen.value &&
    !filterButton.value.contains(event.target) &&
    (!filterBox.value || !filterBox.value.contains(event.target))
  ) {
    toggleFilter();
  }
};

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
  window.addEventListener("resize", updateWidth);
});

onUnmounted(() => {
  window.removeEventListener("resize", updateWidth);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", handleClickOutside);
});
</script>

<style lang="scss" scoped>
.ShowTabToUserCustomer {
  width: 100% !important;
}

.topNav__searchbar_wrapper {
  position: relative !important;
  width: 100% !important;
  height: 50px;
  background: #fff;
  border-radius: 30px !important;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);

  .searchbar_input {
    box-shadow: none !important;
  }
}

.filterbutton_wrapper {
  position: absolute;
  left: 20px;
  top: 7px;
}
.loader {
  height: 40px;
  width: 40px;
  margin-top: 0 !important;
}

.classShowApartmentSow {
  position: relative;
}

@media (min-width: 577px) {
  .filterTitle {
    display: none;
  }
}

@media (max-width: 577px) {
  .filterTitle {
    display: block;

    .filterTitleContainer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 90%;
      margin: 0 auto;
      padding-top: 16px;

      h4 {
        font-family: "iranyekanB", sans-serif;
        font-size: 1.25rem;
        font-weight: 500;
      }

      .closeFilterBtn {
        position: relative;
        width: 32px;
        height: 32px;
        background: #0096c7;
        border-radius: 6px;

        .filterBtnBar {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 86%;
          height: 3px;
          background: #fff;
          border-radius: 6px;

          &:first-of-type {
            transform: translate(-50%, -50%) rotate(45deg);
          }

          &:last-of-type {
            transform: translate(-50%, -50%) rotate(-45deg);
          }
        }
      }
    }
  }
}
</style>
